export class UrlParams {
  static autoLogOut = 'autoLogOut'
}
